import {
  Component,
  createEffect,
  createMemo,
  createSignal,
  Match,
  on,
  Switch,
  useContext,
  type Accessor,
} from 'solid-js'
import type { Engine } from '../../lib/core/engine/Engine.type'
import findByPosition from '../../lib/core/findByPosition'
import type { TilePositionXY } from '../../lib/core/tile_position_xy/TilePositionXY.type'
import { useHoveredPositionSignal } from '../../rx/signal/useHoveredPositionSignal'
import { useSelectedPositionSignal } from '../../rx/signal/useSelectedPositionSignal'
import { useSelectedPositionEntsSignal } from '../../rx/signal/useSelectedPositionEntsSignal'
import { useDraftMoveSignal } from '../../rx/signal/useDraftMoveSignal'
import EngineContext from '../EngineContext'
import AttackPositionCornerWidget from './AttackPositionCornerWidget'
import PositionStackStats from './PositionStackStats'

const TopLeftEngineToolCornerWidget: Component = () => {
  const engine: Engine = useContext(EngineContext)
  const [isExpanded, setIsExpanded] = createSignal<boolean>(false)
  const [getSelectedPosition] = useSelectedPositionSignal(engine)
  const [getHoveredPosition] = useHoveredPositionSignal(engine)
  const [getSelectedPositionEnts] = useSelectedPositionEntsSignal(engine)
  const [getDraftMove] = useDraftMoveSignal(engine)
  createEffect(
    on(getSelectedPosition, (nextSelectedPosition) => {
      if (nextSelectedPosition) {
        setIsExpanded(false)
      }
    })
  )
  // createEffect(() => {
  //   console.log('engine.selectedPosition', deepClone(engine.selectedPosition))
  //   console.log('engine.selectedPositionEnts', deepClone(engine.selectedPositionEnts))
  // })
  // createEffect(() => {
  //   console.log('engine.draftMove?.attackEstimates', deepClone(engine.draftMove?.attackEstimates))
  // })

  const hasAnyEstimates = createMemo(() => {
    const hoveredPosition = getHoveredPosition()
    const draftMove = getDraftMove()
    if (draftMove) {
      const { rangedEstimates, attackEstimates } = draftMove
      if (hoveredPosition && rangedEstimates?.length) {
        return findByPosition(rangedEstimates, hoveredPosition)?.estimate
      }
      // if (selectedTool === SelectedToolId.RangedAttackRadius) {
      //   return rangedEstimates?.length
      // }
      return attackEstimates.length
    }
  })

  return (
    <Switch>
      <Match when={hasAnyEstimates()}>
        <AttackPositionCornerWidget />
      </Match>
      <Match
        when={getSelectedPosition()}
        children={(selectedPosition: Accessor<TilePositionXY>) => {
          return (
            <div
              class="cw cw-sp float-end"
              classList={{ expanded: isExpanded() }}
              onClick={() => setIsExpanded(!isExpanded())}
            >
              <PositionStackStats
                position={selectedPosition()}
                ents={getSelectedPositionEnts()}
                x={isExpanded()}
              />
            </div>
          )
        }}
      />
      <Match when={getSelectedPosition()}>Else</Match>
    </Switch>
  )
}

export default TopLeftEngineToolCornerWidget
